import React, {Component, PropTypes} from 'react';
import AuthorizationLoginForm from '../../components/authorization/index';
import "./index.scss"

export default class loginPage extends Component {
	render() {
		return (
			<div>
				<section id="components-form-demo-normal-login">
					<AuthorizationLoginForm/>
				</section>
				<div className="fancy-foot">
				    <div className="container clearfix">
				        <div className="fancy-foot-quick-link">
				            <span>联系我们<i className="icon-tel"></i><span className="tel-num">400-1520-118</span><i className="icon-tel"></i><span className="tel-num">021-68620117</span></span>
				        </div>
				        <p className="fancy-foot-copyright">
				            Copyright©FancyDigital.All Rights reserved.
				        </p>
				        <p className="fancy-foot-copyright">
				            <a href="http://www.miitbeian.gov.cn/">京ICP备15031715号-2</a>
				        </p>
				    </div>
			    </div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/container/authorization/indexPage.js